type CheckProps = {
  color?: string
  size?: number
  style?: preact.JSX.CSSProperties
}

export const Check = function Check({ color = "#000", size = 32, style }: CheckProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" style={style}>
      <path
        fill={color}
        stroke={color}
        strokeWidth={2}
        d="M29.21 5 32 7.36l-1.149 1.102-19.2 18.569c-1.313 1.102-2.133 1.102-3.282 0L.492 19.478 0 19.005l2.79-2.517 6.892 6.766L29.21 5Z"
      />
    </svg>
  )
}
